const ARTICLE_TOC_MEDIA_QUERY = window.matchMedia('(min-width: 1024px)');

function slugifyArticleHeading(value) {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '') || 'sectie';
}

function getArticleTocTargets() {
  const tocRoot = document.querySelector('.blog-toc[data-blog-toc]');
  const desktopHost = document.querySelector('[data-article-toc-desktop]');
  const mobileHost = document.querySelector('[data-article-toc-mobile]');
  const articleBody = document.querySelector('.article [itemprop="articleBody"]');

  if (!tocRoot || !desktopHost || !mobileHost || !articleBody) {
    return null;
  }

  return {
    tocRoot,
    tocBlock: tocRoot.closest('.shopify-app-block') || tocRoot,
    sourceSection: tocRoot.closest('.shopify-section'),
    desktopHost,
    mobileHost,
    articleBody,
  };
}

function ensureHeadingIds(headings) {
  const usedIds = new Set(
    Array.from(document.querySelectorAll('[id]'))
      .map((element) => element.id)
      .filter(Boolean)
  );

  headings.forEach((heading) => {
    if (heading.id) {
      usedIds.add(heading.id);
      return;
    }

    const baseId = slugifyArticleHeading(heading.textContent.trim());
    let nextId = baseId;
    let index = 2;

    while (usedIds.has(nextId)) {
      nextId = `${baseId}-${index}`;
      index += 1;
    }

    heading.id = nextId;
    usedIds.add(nextId);
  });
}

function buildArticleToc(tocRoot, articleBody) {
  const list = tocRoot.querySelector('[data-blog-toc-list]');

  if (!list) {
    return [];
  }

  const selectors = tocRoot.dataset.headingLevels || 'h2,h3';
  const headings = Array.from(articleBody.querySelectorAll(selectors))
    .filter((heading) => heading.textContent.trim().length > 0);

  if (!headings.length) {
    list.innerHTML = '';
    return [];
  }

  ensureHeadingIds(headings);

  list.innerHTML = headings.map((heading) => {
    const level = heading.tagName.replace('H', '');
    return `
      <li data-level="${level}">
        <a href="#${heading.id}" data-toc-target="${heading.id}">${heading.textContent.trim()}</a>
      </li>
    `;
  }).join('');

  return headings;
}

function moveArticleToc({ tocBlock, sourceSection, desktopHost, mobileHost }) {
  const nextHost = ARTICLE_TOC_MEDIA_QUERY.matches ? desktopHost : mobileHost;

  if (!nextHost || nextHost.contains(tocBlock)) {
    return;
  }

  nextHost.hidden = false;
  nextHost.appendChild(tocBlock);

  if (sourceSection) {
    sourceSection.classList.add('article-toc-source--relocated');
  }
}

function watchArticleTocBreakpoint(callback) {
  if (typeof ARTICLE_TOC_MEDIA_QUERY.addEventListener === 'function') {
    ARTICLE_TOC_MEDIA_QUERY.addEventListener('change', callback);
    return;
  }

  if (typeof ARTICLE_TOC_MEDIA_QUERY.addListener === 'function') {
    ARTICLE_TOC_MEDIA_QUERY.addListener(callback);
  }
}

function initArticleTocScrollSpy(tocRoot, headings) {
  const tocLinks = Array.from(tocRoot.querySelectorAll('[data-toc-target]'));

  if (!tocLinks.length || !headings.length) {
    return;
  }

  const setActiveLink = (activeId) => {
    tocLinks.forEach((link) => {
      link.classList.toggle('is-active', link.dataset.tocTarget === activeId);
    });
  };

  const getAnchorOffset = () => {
    const stickyHeaderHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')
    ) || 0;

    return stickyHeaderHeight + 36;
  };

  const getActivationLine = () => {
    return Math.max(getAnchorOffset(), window.innerHeight * 0.22);
  };

  const updateActiveHeading = () => {
    const activationLine = getActivationLine();
    let activeHeading = headings[0];

    headings.forEach((heading) => {
      const headingTop = heading.getBoundingClientRect().top;

      if (headingTop <= activationLine) {
        activeHeading = heading;
      }
    });

    if (activeHeading) {
      setActiveLink(activeHeading.id);
    }
  };

  const observer = new IntersectionObserver(() => {
    updateActiveHeading();
  }, {
    rootMargin: `-${getActivationLine()}px 0px -55% 0px`,
    threshold: [0, 0.2, 0.5, 1],
  });

  headings.forEach((heading) => observer.observe(heading));

  tocLinks.forEach((link) => {
    link.addEventListener('click', () => {
      setActiveLink(link.dataset.tocTarget);
    });
  });

  updateActiveHeading();
  window.addEventListener('scroll', updateActiveHeading, { passive: true });
  window.addEventListener('resize', updateActiveHeading, { passive: true });
}

function initArticleToc() {
  const targets = getArticleTocTargets();

  if (!targets || targets.tocRoot.dataset.articleTocReady === 'true') {
    return;
  }

  const headings = buildArticleToc(targets.tocRoot, targets.articleBody);

  if (!headings.length) {
    return;
  }

  moveArticleToc(targets);
  initArticleTocScrollSpy(targets.tocRoot, headings);
  watchArticleTocBreakpoint(() => moveArticleToc(targets));
  targets.tocRoot.dataset.articleTocReady = 'true';
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArticleToc, { once: true });
} else {
  initArticleToc();
}
